# Quickstart

A four-step path from zero to a passing flow. About ten minutes.

## 1. Install

```bash
npm i -g @cairntools/cli
```

The `cairn` binary is now on your `$PATH`. Verify with:

```bash
cairn --version
```

## 2. Sign in

```bash
cairn login
```

Opens your browser at `https://cairn-ebf35.web.app/auth/login`. Once you're signed in, the dashboard redirects to your local CLI and stores a refresh token at `~/.cairn/config.json` (0600 perms — never committed).

## 3. Initialize the repo

From the root of the app you're testing:

```bash
cairn init --project-id <id-from-dashboard> --dev-url https://localhost:3000
```

This writes `.graphs/.config.yaml` (committed). The `.config.yaml` declares your environment URLs, secrets policy, and AI-agent extension seams.

## 4. Record your first flow

```bash
cairn record login
```

Opens a local recording UI in your browser. Walk through the login flow while narrating — Cairn transcribes via AssemblyAI, transforms via the LLM adapter, and writes `.graphs/login.yaml` when you're done.

Run it:

```bash
cairn run login
```

Cairn boots a Playwright browser, executes the graph against `dev-url`, and prints step-by-step pass / fail to your terminal. The same artifacts also appear in the dashboard under `/teams/.../projects/.../runs`.

## What's next

- [What is graph-driven testing?](/docs/graph-driven-testing) — the model behind everything
- [Voice walkthrough tips](/docs/voice-tips) — how to talk so the LLM gets your flow right the first time
- [Schema reference](/docs/schema-reference) — every field you can write
- [CLI reference](/docs/cli-reference) — every command + flag
